import React, {Component} from 'react'
import api from '../../source/api'

class Termsandconditions extends Component {

    constructor(props) {
        super(props)
        this.state = {
            title: '',
            content: ''
        }
    }

    componentDidMount = () => {
        window.scrollTo(0, 0)
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use componentDidMount instead.
     */
    componentWillMount = () => {
        api.get('page/get/1')
            .then((response) => {
                if (response.status === 200) {
                    this.setState({
                        title: response.data.title,
                        content: response.data.content
                    })
                }
            })
            .catch((err) => {
                this.setState({
                    title: 'Tartalom feltöltés alatt...'
                })
            })
    }


    render() {
        return (
            <section className='static-page'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <h1 className='text-center'>{this.state.title}</h1>
                        </div>
                    </div>
                    <div className='row'>
                        <div dangerouslySetInnerHTML={{__html: this.state.content}}/>
                    </div>
                </div>
            </section>
        )
    }
}

export default Termsandconditions


// WEBPACK FOOTER //
// ./src/components/pages/termsandconditions.js